import { render, staticRenderFns } from "./MySupportTicketList.vue?vue&type=template&id=1aaa733c"
import script from "./MySupportTicketList.vue?vue&type=script&lang=js"
export * from "./MySupportTicketList.vue?vue&type=script&lang=js"
import style0 from "./MySupportTicketList.vue?vue&type=style&index=0&id=1aaa733c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports